import { render, staticRenderFns } from "./LeavePageDetailsEditForm.vue?vue&type=template&id=15b1e550&scoped=true&"
import script from "./LeavePageDetailsEditForm.vue?vue&type=script&lang=js&"
export * from "./LeavePageDetailsEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b1e550",
  null
  
)

export default component.exports